const translations = {
  en: {
    appName: "kepti",
    tagline: "Pass it on.",
    signIn: "Sign in with Google",
    inviteOnly: "This app is invite-only for KCS families.",
    browse: "Browse",
    search: "Search",
    myListings: "My Listings",
    profile: "Profile",
    sell: "Sell",
    latest: "Latest listings",
    lookingFor: "Parents looking for",
    seeAll: "See all",
    searchPlaceholder: "Search blazer, skort, PE kit...",
    all: "All",
    formal: "Formal",
    daily: "Daily",
    pe: "PE",
    swimming: "Swimming",
    houses: "Houses",
    winter: "Winter",
    accessories: "Accessories",
    condition: "Condition",
    likeNew: "Like new",
    good: "Good",
    used: "Used",
    payment: "Payment",
    mbway: "MBWay",
    cash: "Cash pickup",
    both: "Both",
    price: "Price (€)",
    size: "Size",
    item: "Item",
    selectItem: "Select item...",
    selectSize: "Select size...",
    note: "Note (optional)",
    notePlaceholder: "e.g. small mark on sleeve, zipper works fine",
    addPhoto: "Tap to add photo",
    postListing: "Post listing",
    sellItem: "Sell a uniform item",
    contactSeller: "Contact seller on WhatsApp",
    markSold: "Mark as sold",
    deleteListing: "Delete listing",
    postedBy: "Posted by",
    ago: "ago",
    noListings: "No listings yet. Be the first to sell!",
    myListingsTitle: "My listings",
    active: "Active",
    sold: "Sold",
    signOut: "Sign out",
    language: "Português",
    wantedPost: "Post a wanted ad",
    wanted: "Looking for",
    wantedPlaceholder: "e.g. Boys blazer size 10, any condition",
    post: "Post",
    flag: "Report listing",
    flagged: "Reported — thank you",
    formalUniform: "Formal uniform",
    dailyUniform: "Daily uniform",
    peUniform: "PE uniform",
    housesItems: "Houses",
    winterItems: "Winter / Outerwear",
    swimmingItems: "Swimming",
    accessoriesItems: "Accessories",
  },
  pt: {
    appName: "kepti",
    tagline: "Passa adiante.",
    signIn: "Entrar com Google",
    inviteOnly: "Esta aplicação é exclusiva para famílias KCS.",
    browse: "Explorar",
    search: "Pesquisar",
    myListings: "Os meus anúncios",
    profile: "Perfil",
    sell: "Vender",
    latest: "Últimos anúncios",
    lookingFor: "Pais à procura de",
    seeAll: "Ver todos",
    searchPlaceholder: "Pesquisar blazer, saia-calção, kit PE...",
    all: "Todos",
    formal: "Formal",
    daily: "Diário",
    pe: "Desporto",
    swimming: "Natação",
    houses: "Casas",
    winter: "Inverno",
    accessories: "Acessórios",
    condition: "Estado",
    likeNew: "Como novo",
    good: "Bom estado",
    used: "Usado",
    payment: "Pagamento",
    mbway: "MBWay",
    cash: "Numerário",
    both: "Ambos",
    price: "Preço (€)",
    size: "Tamanho",
    item: "Artigo",
    selectItem: "Seleccionar artigo...",
    selectSize: "Seleccionar tamanho...",
    note: "Nota (opcional)",
    notePlaceholder: "ex: pequena marca na manga, fecho funciona bem",
    addPhoto: "Toque para adicionar foto",
    postListing: "Publicar anúncio",
    sellItem: "Vender artigo de farda",
    contactSeller: "Contactar vendedor no WhatsApp",
    markSold: "Marcar como vendido",
    deleteListing: "Eliminar anúncio",
    postedBy: "Publicado por",
    ago: "atrás",
    noListings: "Sem anúncios ainda. Seja o primeiro a vender!",
    myListingsTitle: "Os meus anúncios",
    active: "Activo",
    sold: "Vendido",
    signOut: "Sair",
    language: "English",
    wantedPost: "Publicar procura",
    wanted: "À procura de",
    wantedPlaceholder: "ex: Blazer menino tamanho 10, qualquer estado",
    post: "Publicar",
    flag: "Reportar anúncio",
    flagged: "Reportado — obrigado",
    formalUniform: "Farda formal",
    dailyUniform: "Farda diária",
    peUniform: "Farda desporto",
    housesItems: "Casas",
    winterItems: "Inverno / Exterior",
    swimmingItems: "Natação",
    accessoriesItems: "Acessórios",
  }
};

export default translations;
